import React, { useEffect, useState } from 'react'
import './MakroNavigator.scss'
import { ReactComponent as ArrowMakroNavigator } from '../../components/assets/MakroPage/ArrowMakroNavigator.svg'


const MakroNavigator = () => {
  const [scrollTop, setScrollTop] = useState(false);
  
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 350) {
        setScrollTop(true);
      } else {
        setScrollTop(false);
      }
    });
    return () => window.removeEventListener("scroll", () => {});
  }, []);
  
  const bottomToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const bottomToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
  });
  };

  return (
    <div className='MakroNavigator'>
      <button
        style={{
          display: scrollTop ? "flex" : "none",
        }}
        onClick={bottomToTop}
      >
        <ArrowMakroNavigator />
      </button>
      <button
        onClick={bottomToBottom}
        style={{
          display: scrollTop ? "flex" : "none",
          right: '123px'
        }}
      >
        <ArrowMakroNavigator style={{transform: 'rotate(180deg)'}}/>
      </button>
    </div>
  )
}

export default MakroNavigator